import React, { useEffect, useState } from "react";
import { styled } from '@mui/material/styles';
import processStyles from './ProcessStyles';
import Separator from "../Separator/Separator";

interface ProcessStep {
  icon: React.ReactNode;
  title: string;
  description: string;
}

type ProcessProps = {
  title: string;
  description: string;
  steps: ProcessStep[];
};

const StyledProcess = styled('section')(({ theme }) => processStyles(theme));


const Process: React.FC<ProcessProps> = ({ title, description, steps }) => {
  const [ scrolled, setScrolled ] = useState(['active-step', '', '', '']);

  const interval = () => {
    setScrolled(['active-step', '', '', '']);
      setTimeout(() => {
        setScrolled(['active-step', 'active-step', '', '']);
      }, 2000)
      setTimeout(() => {
        setScrolled(['active-step', 'active-step', 'active-step', '']);
      }, 4000)
      setTimeout(() => {
        setScrolled(['active-step', 'active-step', 'active-step', 'active-step']);
      }, 6000)
  }

  useEffect(() => {
    interval();
    setInterval(() => {
      interval();
    }, 8000);
  }, []);

  return (
    <StyledProcess className="antialiased">
      <div className="mx-auto max-w-screen-xl px-4 2xl:px-0">
        <div className='w-full flex justify-center'>
          <h2 className="container pt-[4rem] lg:pt-[8rem] text-4xl lg:text-6xl font-semibold text-center pb-[2rem] lg:pb-[1.5rem] px-4 text-wrap w-fit">{title}</h2>
        </div>
        <div className="flex flex-col items-center justify-center my-4">
          <Separator className="mb-10"/>
          <div className="text-xl max-w-[54rem] text-center mx-8 md:mx-24 mb-8">{description}</div>
        </div>
        <div className="mt-6 sm:mt-8 lg:flex lg:gap-8">
          <div className="mt-6 grow sm:mt-8 lg:mt-0">
            <div id="process-step-container" className="space-y-6 p-6 lg:pb-32">

              <ol className="relative ms-3 border-0 border-l-2 border-solid border-gray-200">
                {steps.map((step, index) => (
                  <li key={index} id="process-list-item" className={"mb-12 ms-6 " + scrolled[index]}>
                    <span id="process-step-icon" className="absolute -start-3 flex h-8 w-8 items-center justify-center rounded-full ring-8">
                      {step.icon}
                    </span>
                    <h3 id="process-step-title" className="mb-0.5 text-base font-semibold">{step.title}</h3>
                    <p id="process-step-description" className="text-sm font-normal">{step.description}</p>
                  </li>
                ))}
              </ol>

              <div className="gap-4 sm:flex sm:items-center">
              </div>
            </div>
          </div>
        </div>
      </div>
    </StyledProcess>
  )}
;

export default Process;